/**
 * 'Evaluation.model'
 * @version 1.0.0
 * @author Fernando Torres
 * @copyright Marciano Studio S.C., 2018
 */

export default {
  model () {
    return {
      layoutId: null,
      periodId: null,
      branchId: null,
      startDate: null,
      endDate: null
    }
  },
  rules (model) {
    return {
      layoutId: [{
        required: true
      }],
      periodId: [{
        required: true
      }],
      branchId: [{
        required: true
      }],
      startDate: [{
        required: true
      }],
      endDate: [{
        required: true
      }]
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/evaluation.model.js